import styled from "styled-components"
import { device } from "breakpoints"
import { FlexGrid } from "components/FlexGrid"
export const InternalPageContainer = styled.div``

export const InternalFlexGrid = styled(FlexGrid)`
  margin-bottom: 40px;

  @media ${device.desktop} {
    margin-bottom: 120px;
  }
`

export const RightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media ${device.desktop} {
    margin-top: -280px;
  }
`

export const RHSTeaserCTAContainer = styled.div`
  @media ${device.tablet} {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  @media ${device.desktop} {
    flex-direction: column;
  }
`
